<template>
<v-card tile :flat='flat' class='pb-4' >
  <v-card-title class='overline' >
    <v-btn :loading='loading' @click='touch++' icon small ><v-icon small>replay</v-icon></v-btn>
    {{ $t('comms.messagelist.title') }}
  </v-card-title>
    <communication-list
      @loading='setLoading'
      :touch='touch'
      :params="{'objects_appointment': appointment.id}" >
    </communication-list>

    <template v-if='value && value.process' >
      <v-subheader class='overline mt-2' >Schedule</v-subheader>
      <v-list dense v-for='process in value.process' :key="process.id" class='mt-1' >
        <!-- <v-subheader class='overline my-0 py-0' >
          {{process.name}}
          ({{process.status}})
        </v-subheader> -->
        <v-divider/>
        <template v-for='trigger in process.triggers' >
          <v-list-tile v-if='trigger.task in SCHEDULED_TASKS' :key='trigger.id' >
            <template v-if='trigger.status === "N"' >
              <v-list-tile-action >
                  <v-icon title='Cancel' color='error' >delete</v-icon>
              </v-list-tile-action>
            </template>
            <v-list-tile-content>
              <v-list-tile-title>{{SCHEDULED_TASKS[trigger.task].title}}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-if='trigger.time_offset_in_minutes === 0' >Runs immediately</span>
                <span v-if='trigger.time_offset_in_minutes < 0' >Runs {{ Math.abs(trigger.time_offset_in_minutes)/60 }} hrs before the appointment</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if='trigger.status === "C"' >
                <v-icon title='Task run successfully' color='success' >check</v-icon>
            </v-list-tile-action>
            <template v-if='trigger.status === "N"' >
              <v-list-tile-action >
                  <v-icon small title='Scheduled' color='info' >schedule_send</v-icon>
                <v-list-tile-action-text>scheduled</v-list-tile-action-text>
              </v-list-tile-action>
            </template>
            <v-list-tile-action v-if='trigger.status === "X"' >
                <v-icon small title='Scheduled' color='warning' >event_busy</v-icon>
              <v-list-tile-action-text>cancelled</v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :key='`div-${trigger.id}`' />
        </template>
      </v-list>
    </template>
    <!-- <pre v-text='value' /> -->

    <!-- <v-dialog v-model='sendMessageDialog' >
      <v-toolbar
        v-if='selectedCommunicationTemplate'
        dense dark
        :color='themeColor' >
        <v-toolbar-title >{{selectedCommunicationTemplate.name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click='sendMessageDialog = false' icon><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <send-template
        v-if='selectedCommunicationTemplate'
        template-context='Appointment'
        :template='selectedCommunicationTemplate.slug'
        :context='appointment'
        :touch='sendStateToucher'
        :sender='appointment.practitioner'
        :clients='[appointment.client]'
        :with-send='true'
        @sent='communicationListToucher++'
        @close='sendMessageDialog = false' >
      </send-template>
      <v-alert v-else type='warning' :value='true' >
        {{ $t('comms.warnings.nottemplateselected') }}
      </v-alert>
    </v-dialog> -->
</v-card>
</template>
<script>
// import SendTemplate from '@/components/unibox/SendTemplate'
import CommunicationList from '@/components/lists/CommunicationList'

const SCHEDULED_TASKS = {
  'schedule.tasks.new_appointment_received': {
    title: 'Send notification to practitioner'
  },
  'schedule.tasks.send_appointment_confirmation': {
    title: 'Send confirmation notification to client'
  },
  'schedule.tasks.send_appointment_reminder': {
    title: 'Send reminder to client'
  }
}

export default {
  name: 'NotificationsTab',
  components: {CommunicationList},
  props: {
    value: { type: Object, required: true },
    touch: { type: Number, default: 0 },
    flat: { type: Boolean, default: true }
  },
  data () {
    return {
      SCHEDULED_TASKS: SCHEDULED_TASKS,
      appointment: false,
      sendMessageDialog: false,
      loading: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.appointment = this.value }
      }
    }
  },
  methods: {
    setLoading (loading) {
      this.loading = loading
    }
  },
  i18n: {
    messages: {
      en: {
        comms: {
          title: 'Notifications',
          buttons: {
            send: 'Send a message'
          },
          templatelist: {
            title: 'Choose a message to send'
          },
          messagelist: {
            title: 'The following communications have been sent for this appointment'
          }
        }
      },
      es: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// NotificationsTab.vue?1a53a775